webpackJsonp([1],{

/***/ 128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('v-toolbar',{staticClass:"primary",attrs:{"dark":"","flat":"","extended":"","extension-height":"40","height":"0"}},[_c('v-layout',{attrs:{"slot":"extension","row":""},slot:"extension"},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("報到")])],1)],1)],_vm._v(" "),_c('div',{staticClass:"background"},[_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center mt-2"},[_c('v-btn',{staticClass:"secondary",attrs:{"large":""},on:{"click":_vm.runQR}},[_vm._v("\n          掃描QR碼\n          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("photo_camera")])],1)],1)],1)],1),_vm._v(" "),_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center"},[_c('h2',[_vm._v("或")]),_vm._v(" "),_c('v-text-field',{attrs:{"name":"input-3","label":"輸入班級代碼","value":"","error":_vm.alert2,"id":"classField","data-hj-whitelist":""},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.classLocation($event)}},model:{value:(_vm.classLocationInput),callback:function ($$v) {_vm.classLocationInput=$$v},expression:"classLocationInput"}}),_vm._v(" "),_c('v-btn',{staticClass:"secondary",attrs:{"large":"","disabled":!_vm.classLocationInput.length >= 1},on:{"click":_vm.classLocation}},[_vm._v("提交")])],1)],1)],1),_vm._v(" "),(_vm.alert2)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"type":"error"},model:{value:(_vm.alert2),callback:function ($$v) {_vm.alert2=$$v},expression:"alert2"}},[_vm._v("\n        「"+_vm._s(_vm.userInput)+"」不存在。 請檢查您的代碼，並再試一次\n      ")])],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":_vm.stopQR},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("掃描")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items')],1),_vm._v(" "),_c('div',{staticClass:"scanDialog"},[_c('h1',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]},[_vm._v("處理中...")]),_vm._v(" "),_c('v-alert',{directives:[{name:"show",rawName:"v-show",value:(_vm.QRerror),expression:"QRerror"}],attrs:{"type":"error"}},[_vm._v(_vm._s(_vm.QRerror))]),_vm._v(" "),(_vm.activateQR)?_c('qrcode-reader',{on:{"init":_vm.onInit,"decode":_vm.onDecode}}):_vm._e()],1)],1)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 129:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClassPage_vue__ = __webpack_require__(61);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3aa7ab8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClassPage_vue__ = __webpack_require__(142);
function injectStyle (ssrContext) {
  __webpack_require__(130)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f3aa7ab8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClassPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3aa7ab8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClassPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebaseui__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebaseui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebaseui__);



var config = {
  apiKey: 'AIzaSyD_ahJsWDsGHPxU14BG70CoayMkU76gTK4',
  authDomain: 'taiwan-english.firebaseapp.com',
  databaseURL: 'https://taiwan-english.firebaseio.com',
  projectId: 'taiwan-english'
};

var auth = {
  context: null,
  uiConfig: null,
  ui: null,

  init: function init(context) {
    var _this = this;

    this.context = context;

    __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp(config);
    this.uiConfig = {
      signInSuccessUrl: 'home',
      signInOptions: [__WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth.FacebookAuthProvider.PROVIDER_ID, __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth.GoogleAuthProvider.PROVIDER_ID, __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth.EmailAuthProvider.PROVIDER_ID]
    };
    this.ui = new __WEBPACK_IMPORTED_MODULE_1_firebaseui___default.a.auth.AuthUI(__WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth());

    __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().onAuthStateChanged(function (user) {
      _this.context.$store.dispatch('user/setCurrentUser');

      var requireAuth = _this.context.$route.matched.some(function (record) {
        return record.meta.requireAuth;
      });
      var guestOnly = _this.context.$route.matched.some(function (record) {
        return record.meta.guestOnly;
      });

      if (requireAuth && !user) _this.context.$router.push('auth');else if (guestOnly && user) _this.context.$router.push('home');
    });
  },
  authForm: function authForm(container) {
    this.ui.start(container, this.uiConfig);
  },
  user: function user() {
    return this.context ? __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().currentUser : null;
  },
  logout: function logout() {
    __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().signOut();
  }
};
/* harmony default export */ __webpack_exports__["a"] = (auth);

/***/ }),

/***/ 130:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?[_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"row":"","justify-center":"","align-center":"","fill-height":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":50,"width":5,"color":"green"}})],1)],1)]:_vm._e(),_vm._v(" "),(_vm.alert)?[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.alert),callback:function ($$v) {_vm.alert=$$v},expression:"alert"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Welcome "+_vm._s(_vm.user.displayName)+"!")]),_vm._v(" "),_c('v-card-text',[_vm._v("Looks like you haven't checked into a class before, just tap the button below to get started.")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"","route":"","to":"checkIn"},nativeOn:{"click":function($event){_vm.alert = false}}},[_vm._v("Check into Class")])],1)],1)],1)],1)]:_vm._e(),_vm._v(" "),(_vm.alert2)?[_c('v-layout',{attrs:{"row":"","justify-center":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"type":"error"},model:{value:(_vm.alert2),callback:function ($$v) {_vm.alert2=$$v},expression:"alert2"}},[_vm._v("\n    \""+_vm._s(_vm.searchString)+"\" not found. Please check your spelling and try again.\n  ")])],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_c('v-btn',{attrs:{"medium":"","route":"","to":"checkIn","color":"secondary"}},[_vm._v("Check in to class")])],1)],1)]:_vm._e(),_vm._v(" "),(_vm.pageLoad !== false)?[[_c('v-toolbar',{staticClass:"primary",attrs:{"dark":"","flat":"","extended":"","extension-height":"140","height":"0"}},[_c('v-layout',{attrs:{"slot":"extension","row":""},slot:"extension"},[_c('v-flex',{staticClass:"classinfo px-4 text-xs-center text-lg-center ",attrs:{"xs5":""}},[_c('v-avatar',{staticClass:"elevation-{24}",staticStyle:{"vertical-align":"middle"},attrs:{"size":"100","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.QR.teacherPic,"alt":"avatar"}})]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.QR.teacherName))])],1),_vm._v(" "),_c('v-flex',{staticClass:"classinfo",attrs:{"xs7":""}},[_c('h2',[_vm._v(_vm._s(_vm.QR.classLocation)+"  "+_vm._s(_vm.QR.classLevel))]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.QR.classTime))])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-center ",attrs:{"xs12":""}},[_c('v-btn',{staticClass:"check-in ma-0",attrs:{"block":"","large":"","route":"","to":"checkIn","color":"secondary"}},[_vm._v("報到")])],1)],1),_vm._v(" "),_c('v-list',[_c('v-subheader',[_vm._v("回家功課")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_vm._l((_vm.homework),function(homework,index){return [_c('v-list-tile',{key:homework.homeworkDate,attrs:{"avatar":"","ripple":""},on:{"click":function($event){_vm.indicate(index)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"text--primary"},[_vm._v(_vm._s(homework.homeworkDate))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(homework.description))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-list-tile-action-text'),_vm._v(" "),_c('v-icon',{attrs:{"color":"grey lighten-1"}},[_vm._v("local_post_office")])],1)],1),_vm._v(" "),_c('v-divider')]})],2),_vm._v(" "),(_vm.alert3)?_c('div',[_c('v-alert',{staticClass:"text-xs-center ma-0",attrs:{"value":true,"type":"warning"},on:{"click":function($event){_vm.dialog2 = true}}},[_vm._v("\n        請提供您的電話號碼或是Line ID，讓您的老師能夠與您聯絡。\n       ")]),_vm._v(" "),_c('v-btn',{staticClass:"ma-0",attrs:{"color":"warning","block":""},on:{"click":function($event){_vm.dialog2 = true}}},[_c('v-icon',[_vm._v("create")])],1)],1):_vm._e()],_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.message.homeworkDate))]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.message.description))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("取消")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"","loading":_vm.loading3,"disabled":_vm.loading3,"href":this.message.homeworkURL},nativeOn:{"click":function($event){_vm.loading3 = true}}},[_vm._v("開啟")])],1)],1)],1)],1)]:_vm._e(),_vm._v(" "),[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.dialog2),callback:function ($$v) {_vm.dialog2=$$v},expression:"dialog2"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(" 聯絡資料")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-form',{ref:"form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-flex',[_c('v-text-field',{attrs:{"name":"input-1-1","rules":_vm.nameRules,"label":"電話號碼","hint":"","single-line":"","prepend-icon":"phone","required":""},model:{value:(_vm.phoneNumber),callback:function ($$v) {_vm.phoneNumber=$$v},expression:"phoneNumber"}})],1),_vm._v(" "),_c('v-flex',[_c('v-text-field',{attrs:{"name":"email","label":"LINE ID","hint":"","single-line":"","prepend-icon":"local_post_office"},model:{value:(_vm.lineID),callback:function ($$v) {_vm.lineID=$$v},expression:"lineID"}})],1)],1)],1)],1),_vm._v(" "),_c('small',[_vm._v("*必填")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},nativeOn:{"click":function($event){_vm.dialog2 = false}}},[_vm._v("取消")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},on:{"click":_vm.firestore2}},[_vm._v("儲存")])],1)],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":6000,"bottom":true,"multi-line":true},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n        聯絡資料已成功接收\n        "),_c('v-btn',{attrs:{"flat":"","color":"pink"},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_vm._v("關閉")])],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":6000,"bottom":true,"multi-line":true},model:{value:(_vm.succesfulCheckin),callback:function ($$v) {_vm.succesfulCheckin=$$v},expression:"succesfulCheckin"}},[_vm._v("\n      成功報到\n        "),_c('v-btn',{attrs:{"flat":"","color":"pink"},nativeOn:{"click":function($event){_vm.snackbar2 = false}}},[_vm._v("關閉")])],1)]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Auth_vue__ = __webpack_require__(62);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_480d946f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Auth_vue__ = __webpack_require__(145);
function injectStyle (ssrContext) {
  __webpack_require__(144)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-480d946f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Auth_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_480d946f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Auth_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 144:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 145:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('div',{staticClass:"sign-in"},[_c('v-flex',{staticClass:"text-lg-center text-xs-center",attrs:{"xs12":"","lg12":""}},[_c('img',{staticClass:"mt-5",attrs:{"src":__webpack_require__(146)}})]),_vm._v(" "),_c('div',{attrs:{"id":"firebaseui-auth-container"}}),_vm._v(" "),_c('p',{staticClass:"text-xs-center text-lg-center white--text mt-5"},[_c('a',{staticClass:"white--text",attrs:{"href":"http://taiwaneng.com/privacy-policy"}},[_vm._v("隱私權政策")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/App Sign In Free English Class.57de81b.png";

/***/ }),

/***/ 147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_514718e4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Help_vue__ = __webpack_require__(148);
var normalizeComponent = __webpack_require__(7)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_514718e4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Help_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_c('h1',[_vm._v("Need help?")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aboutMissionaries_vue__ = __webpack_require__(63);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ddada38a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aboutMissionaries_vue__ = __webpack_require__(157);
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aboutMissionaries_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ddada38a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aboutMissionaries_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","lg6":""}},[_c('v-menu',{ref:"menu1",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},model:{value:(_vm.menu1),callback:function ($$v) {_vm.menu1=$$v},expression:"menu1"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date Available","persistent-hint":"","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.dateFormatted),callback:function ($$v) {_vm.dateFormatted=$$v},expression:"dateFormatted"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"zh-cn"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.menu1 = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.menu1 = false}}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm5":""}},[_c('v-dialog',{ref:"dialog",attrs:{"return-value":_vm.time,"persistent":"","lazy":"","full-width":"","width":"290px"},on:{"update:returnValue":function($event){_vm.time=$event}},model:{value:(_vm.modal2),callback:function ($$v) {_vm.modal2=$$v},expression:"modal2"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Time of Lesson","prepend-icon":"access_time","readonly":""},slot:"activator",model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}}),_vm._v(" "),_c('v-time-picker',{attrs:{"format":"24hr","actions":""},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.modal2 = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.dialog.save(_vm.time)}}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{on:{"click":_vm.saveAppointment}},[_vm._v("Submit")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WOTD_vue__ = __webpack_require__(64);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a6cd94f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WOTD_vue__ = __webpack_require__(160);
function injectStyle (ssrContext) {
  __webpack_require__(159)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a6cd94f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WOTD_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a6cd94f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WOTD_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 159:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 16:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "db", function() { return db; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_qrcode_reader__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuefire__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_app__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_firebase_firestore__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_firebase_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_firebase_firestore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_store_js__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_analytics__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_raven_js__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_raven_js_plugins_vue__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_raven_js_plugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_raven_js_plugins_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_axios__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_axios__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_axios__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


















__WEBPACK_IMPORTED_MODULE_13_raven_js___default.a.config('https://5abe71266a774037b0f3ff0c448cf0f1@sentry.io/1221611').addPlugin(__WEBPACK_IMPORTED_MODULE_14_raven_js_plugins_vue___default.a, __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]).install();

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuetify___default.a, { theme: {
    primary: '#4CAF50',
    secondary: '#81c784',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  } });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_qrcode_reader__["default"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vuefire__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_vue_analytics___default.a, {
  id: 'UA-111818409-2',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* router */]
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_16_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_15_axios___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* router */],
  store: __WEBPACK_IMPORTED_MODULE_11__store_store_js__["a" /* store */],
  beforeCreate: function beforeCreate() {
    __WEBPACK_IMPORTED_MODULE_3__auth__["a" /* default */].init(this);
  },

  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
  template: '<App/>'
});

var db = __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.firestore();

/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"inspire"}},[_c('div',{staticClass:"font shadedbg",attrs:{"id":"date"}},[_vm._v("\n      "+_vm._s(_vm.date)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"font centered shadedbg",attrs:{"id":"all"}},[_c('a',{attrs:{"id":"link","href":"#","target":"_blank"}},[_c('div',{attrs:{"id":"word"}},[_vm._v(_vm._s(this.WOTD.word))])]),_vm._v(" "),_c('div',{attrs:{"id":"pronun"}}),_vm._v(" "),_c('div',{attrs:{"id":"defin"}},[_vm._v(_vm._s(this.WOTD.definitions[0].text))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 162:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 186:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 191:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_user__ = __webpack_require__(192);





__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* default */].Store({
  state: {
    teacherName: 'President Jergensen',
    classLocation: '',
    snackbar2: false,
    user: {
      id: ''
    }
  },
  mutations: {
    classLocation: function classLocation(state, payload) {
      state.classLocation = payload;
    },
    successfulCheckin: function successfulCheckin(state) {
      state.snackbar2 = true;
      setTimeout(function () {
        state.snackbar2 = false;
      }, 6000); // Has a 6 second timeout so that the confirmation snackbar will not reappear even when the user has not registered a class https://www.w3schools.com/jsref/met_win_settimeout.asp
    }
  },
  actions: {
    signin: function signin(_ref, _ref2) {
      var commit = _ref.commit;
      var email = _ref2.email,
          password = _ref2.password;

      commit('setUser', { id: 1, firstName: 'Tony', lastName: 'Stark' });
    },

    classLocation: function classLocation(_ref3, payload) {
      var commit = _ref3.commit;

      commit('classLocation', payload);
    }
  },
  modules: {
    user: __WEBPACK_IMPORTED_MODULE_2__modules_user__["a" /* default */]
  }
});

/***/ }),

/***/ 192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_js__ = __webpack_require__(13);


var state = {
  user: null
};

var getters = {
  user: function user(state) {
    return state.user;
  },
  isLogged: function isLogged(state) {
    return state.user !== null;
  }
};

var mutations = {
  setUser: function setUser(state, user) {
    state.user = user;
  }
};

var actions = {
  setCurrentUser: function setCurrentUser(_ref) {
    var commit = _ref.commit;

    commit('setUser', __WEBPACK_IMPORTED_MODULE_0__auth_js__["a" /* default */].user());
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      sideNav: false,
      menuItems: [{ icon: 'home', title: '我的班級', link: '/classpage' }, /* My Class */
      { icon: 'location_on', title: ' 報到', link: '/checkin' }, /* Check in */
      { icon: 'book', title: ' WOTD', link: '/wotd'
        /* {icon: 'face', title: 'About Missionaries', link: '/about-missionaries'} */
        /* {icon: 'help', title: 'Help', link: '/help'} */
      }]
    };
  },

  name: 'App',
  computed: {
    user: function user() {
      return this.$store.getters['user/user'];
    }
  },
  methods: {
    logOut: function logOut() {
      __WEBPACK_IMPORTED_MODULE_0__auth__["a" /* default */].logout();
    }
  }
});

/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase_app__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      classLocationInput: '',
      alert: '',
      alert2: false,
      today: '',
      dialog: false,
      paused: false,
      content: '',
      activateQR: false,
      loading: true,
      userInput: '',
      QRerror: ''
    };
  },

  methods: {
    classLocation: function classLocation() {
      var _this = this;

      this.$store.dispatch('classLocation', this.classLocationInput.toLowerCase());
      var trimString = this.classLocationInput.trim();
      var originalString = trimString; /* .toLowerCase()) */ /* TODO CHANGE THIS CODE BACK */
      var classArea = originalString.slice(0, -3); /* Slices everything but the last 3 characters away */
      var classLevel = originalString.substr(-3); /* Displays the class level (the last 3 Chinese characters in the string) */
      this.date();
      __WEBPACK_IMPORTED_MODULE_2__main__["db"].collection('English_Units').doc(classArea).collection('Class Level').doc(classLevel).get().then(function (doc) {
        /* TODO CHANGE THIS CODE BACK take out the mult split string */
        if (doc.exists) {
          console.log('set date for classRole');
          __WEBPACK_IMPORTED_MODULE_2__main__["db"].collection('English_Units').doc(classArea).collection('Class Level').doc(classLevel).collection('classRole').doc(_this.today).set({ /* TODO CHANGE THIS CODE BACK take out the mult split string */
            date: _this.today
          }, { merge: true });
          /* /English_Units/Xizhi/Class Level/underwater knitting/classRole/06-22-2018/students */
          __WEBPACK_IMPORTED_MODULE_2__main__["db"].collection('English_Units').doc(classArea).collection('Class Level').doc(classLevel).collection('classRole').doc(_this.today).collection('students').doc(_this.user.uid).set({ /* TODO CHANGE THIS CODE BACK take out the mult split string */
            studentID: _this.user.uid,
            studentEmail: _this.user.email
          }, { merge: true });
          __WEBPACK_IMPORTED_MODULE_2__main__["db"].collection('Users').doc(_this.user.uid).set({ lastSearchAttempt: originalString, location: originalString, studentName: _this.user.displayName, photo: _this.user.photoURL + '?width=9999', uid: _this.user.uid, email: _this.user.email }, { merge: true });
          console.log('success');
          _this.alert2 = false;
          _this.$store.commit('successfulCheckin'); // Activates the successful checkin toast on the ClassPage
          _this.$router.replace('classpage');
        } else {
          console.log('class location not located');
          _this.userInput = _this.classLocationInput;
          _this.alert2 = true;
          _this.dialog = false;
          document.getElementById('classField').blur(); // Blurs the element so that the keyboard will disappear and allow the user to see the alert
          __WEBPACK_IMPORTED_MODULE_2__main__["db"].collection('AppLogs').doc(_this.user.uid).set({ failedSearchAttempt: originalString, lastSearchedAt: __WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.firestore.FieldValue.serverTimestamp(), email: _this.user.email }, { merge: true }); // Logs the failed search attempt
        }
      });
    },
    date: function date() {
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1; // January is 0!
      var yyyy = today.getFullYear();

      if (dd < 10) {
        dd = '0' + dd;
      }

      if (mm < 10) {
        mm = '0' + mm;
      }

      today = mm + '-' + dd + '-' + yyyy;
      this.today = today;
      console.log(today);
    },
    onDecode: function onDecode(content) {
      if (content !== '') {
        if (confirm('您將報到.... "' + content + '"')) {
          var sanitizedInput = content.replace('/', ' ');
          /* TODO find the correct way to catch an error if the user scans a QR code containing a non alpha numeric string */
          this.classLocationInput = sanitizedInput;
          this.classLocation();
        } else {}
      } else {
        console.log('QR Reader returned blank string');
      }
    },
    runQR: function runQR() {
      this.activateQR = true;
      this.dialog = true;
    },
    stopQR: function stopQR() {
      this.activateQR = false;
      this.loading = true;
    },
    onInit: function onInit(promise) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return promise;

              case 3:
                _context.next = 8;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context['catch'](0);

                if (_context.t0.name === 'NotAllowedError') {
                  // user denied camera access permisson
                  _this2.QRerror = '尚未允許相機存取權限'; /* Camera Access Denied */
                } else if (_context.t0.name === 'NotFoundError') {
                  // no suitable camera device installed
                  _this2.QRerror = '找不到合適的相機裝置'; /* Camera Not Found */
                } else if (_context.t0.name === 'NotSupportedError') {
                  // page is not served over HTTPS (or localhost)
                  _this2.QRerror = '沒有掃QR的功能'; /* QR Not Supported */
                } else if (_context.t0.name === 'NotReadableError') {
                  // maybe camera is already in use
                  _this2.QRerror = '其他應用程式正在使用相機'; /* Camera Currently Being Used By Other Application */
                } else if (_context.t0.name === 'OverconstrainedError') {
                  // passed constraints don't match any camera. Did you requested the front camera although there is none?
                  _this2.QRerror = '檢查是否正確使用相機裝置'; /* Camera Not Found */
                } else {
                  // browser is probably lacking features (WebRTC, Canvas)
                  _this2.QRerror = '您的瀏覽器沒有掃QR的功能'; /* QR Scanner Not Supported By Your Browser */
                }

              case 8:
                _context.prev = 8;

                _this2.loading = false;
                return _context.finish(8);

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 5, 8, 11]]);
      }))();
    }
  },
  computed: {
    user: function user() {
      return this.$store.getters['user/user'];
    }
  }
});

/***/ }),

/***/ 61:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(16);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      paused: false,
      content: '',
      QR: [],
      homework: [],
      classLocation: [],
      message: [],
      loading: true,
      alert: false,
      alert2: false,
      alert3: true,
      pageLoad: false,
      dialog: false,
      dialog2: false,
      loading3: false,
      searchString: '',
      userContactInfo: {},
      phoneNumber: '',
      lineID: '',
      snackbar: false,
      snackbar2: false,
      email: '',
      nameRules: [function (v) {
        return !!v || '電話號碼必填';
      }, /* Phone number is required */
      function (v) {
        return v.length >= 10 || '電話號碼必填';
      } /* Phone number is required */
      ],
      valid: false
    };
  },
  created: function created() {
    this.firestore();
  },

  methods: {
    indicate: function indicate(index) {
      console.log(index);
      this.dialog = true;
      this.message = this.homework[index];
      console.log(this.message.title);
    },
    firestore: function firestore() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__main__["db"].collection('Users').doc(this.user.uid).get().then(function (doc) {
        if (doc.exists) {
          var userInfo = doc.data();
          console.log(userInfo.location);
          _this.searchString = userInfo.location;
          var classArea = userInfo.location.slice(0, -3); /* Slices everything but the last 3 characters away */
          var classLevel = userInfo.location.substr(-3); /* Displays the class level (the last 3 Chinese characters in the string) */
          _this.userContactInfo = userInfo;
          _this.checkContactInfo();
          /* /English_Units/Xizhi/Class Level/underwater knitting/classRole/06-22-2018/students */
          __WEBPACK_IMPORTED_MODULE_2__main__["db"].collection('English_Units').doc(classArea).collection('Class Level').doc(classLevel).get().then(function (doc) {
            /* TODO CHANGE THIS CODE BACK take out the mult split string */
            if (doc.exists) {
              var classDetails = doc.data();
              _this.QR = classDetails;
              __WEBPACK_IMPORTED_MODULE_2__main__["db"].collection('English_Units').doc(classArea).collection('Class Level').doc(classLevel).collection('homework').orderBy('homework_timestamp', 'desc').limit(4).get().then(function (snap) {
                /* TODO CHANGE THIS CODE BACK take out the mult split string */ // The homework is orderedBy newest to oldest and only shows the latest 5 assignemnts *.limit()*
                var items = snap.docs.reduce(function (res, item) {
                  return (/* Homework info returned from Firestore must be modified using this function  */
                    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, res, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, item.id, item.data()))
                  );
                }, {});
                _this.homework = items;
                _this.pageLoad = true;
                _this.loading = false;
              });
            } else {
              console.log('error 2');
              _this.loading = false;
              _this.alert2 = true;
            }
          });
        } else {
          // doc.data() will be undefined in this case
          console.log('No such document! user has no location saved in their user document. error 1');
          _this.alert = true;
          _this.loading = false;
        }
      });
    },
    firestore2: function firestore2() {
      this.$refs.form.validate();
      if (this.valid) {
        __WEBPACK_IMPORTED_MODULE_2__main__["db"].collection('Users').doc(this.user.uid).set({
          phoneNumber: this.phoneNumber,
          lineID: this.lineID
        }, { merge: true });
        this.alert3 = false;
        this.dialog2 = false;
        this.snackbar = true;
      } else {
        console.log('Not validated');
      }
    },
    checkContactInfo: function checkContactInfo() {
      if ('phoneNumber' in this.userContactInfo || 'lineID' in this.userContactInfo) {
        this.alert3 = false;
        console.log('Phone number or Line ID IS stored');
      } else {
        console.log('No phone number or Line ID stored');
      }
    }
  },
  computed: {
    user: function user() {
      return this.$store.getters['user/user'];
    },
    succesfulCheckin: function succesfulCheckin() {
      return this.$store.state.snackbar2;
    }
  }
});

/***/ }),

/***/ 62:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'auth',
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0__auth__["a" /* default */].authForm('#firebaseui-auth-container');
  }
});

/***/ }),

/***/ 63:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(16);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      date: null,
      dateFormatted: null,
      menu1: false,
      time: null,
      modal2: false,
      userInfo: []
    };
  },


  computed: {
    user: function user() {
      return this.$store.getters['user/user'];
    }
  },

  watch: {
    date: function date(val) {
      this.dateFormatted = this.formatDate(this.date);
    }
  },

  methods: {
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split = date.split('-'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return month + '/' + day + '/' + year;
    },
    parseDate: function parseDate(date) {
      if (!date) return null;

      var _date$split3 = date.split('/'),
          _date$split4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split3, 3),
          month = _date$split4[0],
          day = _date$split4[1],
          year = _date$split4[2];

      return year + '-' + month.padStart(2, '0') + '-' + day.padStart(2, '0');
    },
    saveAppointment: function saveAppointment() {
      var _this = this;

      if (this.date !== null && this.time !== null) {
        __WEBPACK_IMPORTED_MODULE_1__main__["db"].collection('Users').doc(this.user.email).get().then(function (doc) {
          // retreive user location and save appointment info there
          if (doc.exists) {
            console.log('Working');
            _this.userInfo = doc.data();
            console.log(_this.userInfo.location);
            __WEBPACK_IMPORTED_MODULE_1__main__["db"].collection('QR').doc(_this.userInfo.location).collection('appointments').doc(_this.user.email).set({
              studentID: _this.user.email,
              date: _this.dateFormatted,
              time: _this.time
            }, { merge: true });
          }
        });
      } else {
        console.log('No time or date selected');
      }
    }
  }
});

/***/ }),

/***/ 64:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      WOTD: {},
      date: {}
    };
  },
  created: function created() {
    this.test();
  },

  methods: {
    test: function test() {
      var _this = this;

      this.axios.get('https://api.wordnik.com/v4/words.json/wordOfTheDay?api_key=3e652199b14a62ddad23719c96ccd6f0cb40c7185ecf46000').then(function (response) {
        console.log(response.data);
        _this.WOTD = response.data;
        console.log(_this.WOTD);
        _this.getDate();
      });
    },
    test2: function test2() {
      this.axios.post('https://api.cognitive.microsoft.com/sts/v1.0/issueToken?Subscription-Key=b2eb8c3530ef43a28d10d6ae8fa68025').then(function (response) {
        console.log(response.data);
      });
    },
    getDate: function getDate() {
      var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      var date = new Date();
      var day = date.getDate();
      var monthIndex = date.getMonth();
      var year = date.getFullYear();
      var marker;
      if (day === 1 || day === 21) {
        marker = 'st';
      } else if (day === 2 || day === 22) {
        marker = 'nd';
      } else if (day === 3 || day === 23) {
        marker = 'rd';
      } else {
        marker = 'th';
      }
      this.date = monthNames[monthIndex] + ' ' + day + marker + ' ' + year;
    },
    placeImage: function placeImage(w, h) {
      w = window.screen.availWidth;
      h = window.screen.availHeight;

      document.body.innerHTML += '<img src=' + '"https://source.unsplash.com/collection/347929/' + w + 'x' + h + '"' + ' id="bg" alt="">';
    }
  }
});

/***/ }),

/***/ 75:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(40);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3a891b6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(90);
function injectStyle (ssrContext) {
  __webpack_require__(76)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3a891b6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 76:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.user != null)?[_c('v-navigation-drawer',{attrs:{"temporary":"","fixed":""},model:{value:(_vm.sideNav),callback:function ($$v) {_vm.sideNav=$$v},expression:"sideNav"}},[_c('v-list',{staticClass:"pa-0"},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[(_vm.user.photoURL != null)?_c('img',{attrs:{"src":_vm.user.photoURL}}):_vm._e()]),_vm._v(" "),_c('v-list-tile-content',[(_vm.user.displayName != null)?_c('v-list-tile-title',[_vm._v(_vm._s(_vm.user.displayName))]):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{staticClass:"pt-0"},[_vm._l((_vm.menuItems),function(item){return _c('v-list-tile',{key:item.title,attrs:{"router":"","to":item.link}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-action'),_vm._v(" "),_c('v-list-tile-content',[_vm._v(_vm._s(item. title)+" ")])],1)}),_vm._v(" "),_c('v-list-tile',{on:{"click":_vm.logOut}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("exit_to_app")])],1),_vm._v(" "),_c('v-list-tile-action'),_vm._v(" "),_c('v-list-tile-content',[_vm._v("登出")])],1)],2)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"primary",attrs:{"dark":""}},[_c('v-toolbar-side-icon',{staticClass:"hidden-sm-and-up",on:{"click":function($event){_vm.sideNav =!_vm.sideNav}}}),_vm._v(" "),_c('v-toolbar-title'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',{staticClass:"hidden-xs-only"},[_vm._l((_vm.menuItems),function(item){return _c('v-btn',{key:item.title,attrs:{"flat":"","router":"","to":item.link}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v(_vm._s(item.icon))]),_vm._v("\n          "+_vm._s(item.title)+"\n        ")],1)}),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.logOut}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("exit_to_app")]),_vm._v("\n          登出")],1)],2)],1)]:_vm._e(),_vm._v(" "),_c('main',[_c('router-view')],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 91:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return router; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Class_CheckIn__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Class_ClassPage__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_User_Auth__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_User_Help__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Class_aboutMissionaries__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Class_WOTD__ = __webpack_require__(158);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [{ path: '/auth', name: 'auth', component: __WEBPACK_IMPORTED_MODULE_5__components_User_Auth__["a" /* default */], meta: { guestOnly: true } }, { path: '/checkin', name: 'checkin', component: __WEBPACK_IMPORTED_MODULE_3__components_Class_CheckIn__["a" /* default */], meta: { requireAuth: true } }, { path: '/classpage', name: 'ClassPage', component: __WEBPACK_IMPORTED_MODULE_4__components_Class_ClassPage__["a" /* default */], meta: { requireAuth: true } }, { path: '/help', name: 'Help', component: __WEBPACK_IMPORTED_MODULE_6__components_User_Help__["a" /* default */], meta: { requireAuth: true } }, { path: '/wotd', name: 'WOTD', component: __WEBPACK_IMPORTED_MODULE_8__components_Class_WOTD__["a" /* default */], meta: { requireAuth: true } }, { path: '/about-missionaries', name: 'aboutMissionaries', component: __WEBPACK_IMPORTED_MODULE_7__components_Class_aboutMissionaries__["a" /* default */], meta: { requireAuth: true } }, { path: '*', redirect: '/classpage' }];

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: routes
});

router.beforeEach(function (to, from, next) {
  var currentUser = __WEBPACK_IMPORTED_MODULE_2__auth__["a" /* default */].user();
  var requireAuth = to.matched.some(function (record) {
    return record.meta.requireAuth;
  });
  var guestOnly = to.matched.some(function (record) {
    return record.meta.guestOnly;
  });

  if (requireAuth && !currentUser) next('auth');else if (guestOnly && currentUser) next('classpage');else next();
});

/***/ }),

/***/ 93:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckIn_vue__ = __webpack_require__(44);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26838c1f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckIn_vue__ = __webpack_require__(128);
function injectStyle (ssrContext) {
  __webpack_require__(94)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26838c1f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26838c1f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckIn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 94:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[16]);


// WEBPACK FOOTER //
// static/js/app.605598806d168e17468f.js